"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isNumber = _interopRequireDefault(require("lodash/isNumber"));
var _isString = _interopRequireDefault(require("lodash/isString"));
/**
 * Utilities for working with strings.
 * @module StringUtils
 */
const StringUtils = {
  /**
   * Removes spaces from the provided string.
   * @static
   * @function removeSpaces
   * @param {String} str - The string to remove spaces from.
   * @example
   * StringUtils.removeSpaces('Foo Bar'); // 'FooBar'
   * @returns {String} - The string with no spaces.
   */
  removeSpaces(str) {
    if (!(0, _isString.default)(str)) {
      throw new Error('You can only remove spaces from a string.');
    }
    return str.replace(/\s+/g, '');
  },
  /**
   * Pads a number with a leading zero if necessary and returns it as a string representation.
   * @static
   * @function padWith
   * @param {Number} num - The number to pad.
   * @param {String} [pad='0'] - The string to pad the number with.
   * @example
   * StringUtils.padWith(1);
   * @returns {String} - The padded number.
   */
  padWith(num, pad = '0') {
    if (!(0, _isNumber.default)(num)) {
      throw new Error('You can only pad numbers.');
    }
    return num < 10 ? `${pad}${num}` : `${num}`;
  }
};
var _default = exports.default = StringUtils;